export default "__VITE_ASSET__BVxWCt$0__"